/**
 * dd-manager.ts 10.0.1
 * Copyright (c) 2021 Alain Dumesny - see GridStack root license
 */
/**
 * globals that are shared across Drag & Drop instances
 */
export class DDManager {
}
//# sourceMappingURL=dd-manager.js.map